enum PermissionMode {
  fieldSharing = 'fieldSharing',
}

export default PermissionMode;
